"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchToolbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup/ButtonGroup"));
const dispatches_styles_1 = require("./dispatches-styles");
const detail_context_1 = require("../../../composite/detail/detail-context");
const detail_action_button_1 = require("../../../composite/action-button/detail/detail-action-button");
const dispatches_api_1 = require("./dispatches-api");
const ess_types_1 = require("../ess-types");
function DispatchToolbar({ url }) {
    var _a, _b;
    const intl = react_intl_1.useIntl();
    const classes = dispatches_styles_1.useStyles();
    const { source } = react_1.useContext(detail_context_1.DetailContext);
    const send = react_1.useMemo(() => dispatches_api_1.sendFactory(url), [url]);
    const deliver = react_1.useMemo(() => dispatches_api_1.deliverFactory(url), [url]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined", className: classes.toolbarIndentLeft },
                ((_a = source.data) === null || _a === void 0 ? void 0 : _a.state) === ess_types_1.DispatchState.CREATED && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "ESS_DISPATCH_SEND", apiCall: send, buttonLabel: intl.formatMessage({
                        id: 'ESS_DISPATCH_TOOLBAR_BTN_SEND',
                        defaultMessage: 'Odeslat',
                    }), buttonTooltip: intl.formatMessage({
                        id: 'ESS_DISPATCH_TOOLBAR_TOOLTIP_SEND',
                        defaultMessage: 'Otevrě dialog s ručním odesláním',
                    }), dialogTitle: intl.formatMessage({
                        id: 'ESS_DISPATCH_SEND_DIALOG_TITLE',
                        defaultMessage: 'Varování',
                    }), dialogText: intl.formatMessage({
                        id: 'ESS_DISPATCH_SEND_DIALOG_TEXT',
                        defaultMessage: 'Skutečně chcete označit vypravení za odeslané ?',
                    }) })),
                ((_b = source.data) === null || _b === void 0 ? void 0 : _b.state) === ess_types_1.DispatchState.SENT && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "ESS_DISPATCH_DELIVER", apiCall: deliver, buttonLabel: intl.formatMessage({
                        id: 'ESS_DISPATCH_TOOLBAR_BTN_DELIVER',
                        defaultMessage: 'Doručit',
                    }), buttonTooltip: intl.formatMessage({
                        id: 'ESS_DISPATCH_TOOLBAR_TOOLTIP_DELIVER',
                        defaultMessage: 'Otevrě dialog s ručním doručením',
                    }), dialogTitle: intl.formatMessage({
                        id: 'ESS_DISPATCH_DELIVER_DIALOG_TITLE',
                        defaultMessage: 'Varování',
                    }), dialogText: intl.formatMessage({
                        id: 'ESS_DISPATCH_DELIVER_DIALOG_TEXT',
                        defaultMessage: 'Skutečně chcete označit vypravení za doručené ?',
                    }) }))))));
}
exports.DispatchToolbar = DispatchToolbar;
//# sourceMappingURL=dispatches-detail-toolbar.js.map